// Libs
import React, { useEffect } from 'react';
// Context
import classNames from 'classnames';
import { useComponentsPool } from '../../../ComponentsPool';
import useWosCredentials from '../../authentication/useWosCredentials';
import useRouter from '../../../utils/hook/useRouter';
import { useSelector } from 'react-redux';

const splittedUrl = window.location.hostname.split('.');
const URL_SUFFIX = splittedUrl[splittedUrl.length - 1] === 'io' ? 'io' : 'com';
const WOS_URL = `https://wos.merciyanis.${URL_SUFFIX}/device-alerts`;

export default () => {
  const iframeRef = React.useRef(null);
  useWosCredentials(iframeRef, WOS_URL);
  const { Component } = useComponentsPool();
  const { history } = useRouter();

  useEffect(() => {
    // Change /devices to /devices?view=list
    if (!window.location.search.includes('?view=failures')) {
      history.push({ search: 'view=list' });
    }
  }, []);

  const deviceTabs = [
    {
      searchQuery: "list",
      name: "Tous"
    },
    {
      searchQuery: "failures",
      name: "Anomalies"
    },
    {
      searchQuery: "offer",
      name: "Catalogue IoT"
    },
  ]

  return (
    <div className='devices-tables-wrapper'>
      <div className='dashboard-tabs-container'>
        {deviceTabs.map((tab, idx) => (
          <div
            className={classNames([
              'dashboard-tab',
              { 'selected': tab.searchQuery === new URLSearchParams(window.location.search).get("view") }
            ])}
            onClick={() => history.push({ search: `view=${tab.searchQuery}` })}
            key={idx}
          >
            {tab.name}
          </div>
        ))}
      </div>
      {new URLSearchParams(window.location.search).get("view") === 'failures' && (
        <iframe
          ref={iframeRef}
          className='devices-failures-wrapper'
          id="inlineFrameExample"
          title="Inline Frame Example"
          frameBorder="0"
          src={WOS_URL}
        />
      )}
      {new URLSearchParams(window.location.search).get("view") === 'offer' && (
        <iframe
          className='devices-failures-wrapper'
          id="inlineFrameExample"
          title="Inline Frame Example"
          frameBorder="0"
          src="https://merciyanis-platform-showcase.lovable.app/iot"
        >
        </iframe>
      )}
      {new URLSearchParams(window.location.search).get("view") === 'list' && (
        <Component componentName={'DevicesTable'} onRowClick={() => { }} />
      )}
    </div>
  );
};
